import { render, staticRenderFns } from "./Hypotheses.vue?vue&type=template&id=0a85ac6c&"
import script from "./Hypotheses.vue?vue&type=script&lang=js&"
export * from "./Hypotheses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports